import FileDownloadIcon from '@mui/icons-material/FileDownload';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

import AppModal from '../appModal.component';
import WithLogin from '../withLogin.component';
import ReportPreview from './reportPreview.Component';

const ReportDownload = props => {
    const [show, setModalShow] = useState(props.open);
    const [downloadCompleteText, setDownloadCompleteText] = useState(
        'Download Complete Report',
    );

    const handleModalClose = () => {
        props.handleReportClose(false);
        setModalShow(false);
    };

    useEffect(() => {
        setModalShow(props.open);
        if (props.downloadCompleteText) {
            setDownloadCompleteText(props.downloadCompleteText);
        }
    }, [props]);

    const downloadFile = url => {
        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.click();
    };

    return (
        <AppModal
            size="xl"
            show={show}
            onHide={handleModalClose}
            modalTitle={props.title ?? 'Report'}
            scrollable
            footer={
                <>
                    {props.summaryUrl && (
                        <Button
                            color="primary"
                            onClick={() => downloadFile(props.summaryUrl)}>
                            <FileDownloadIcon />
                            Download Summary
                        </Button>
                    )}
                    <Button
                        color="primary"
                        onClick={() => downloadFile(props.url)}>
                        <FileDownloadIcon />
                        {downloadCompleteText}
                    </Button>
                </>
            }>
            <ReportPreview url={props.url} showPagination />
        </AppModal>
    );
};

export default WithLogin(ReportDownload);
